import CalendarioDisponibilidades from './CalendarioDisponibilidades.vue';
import CalendarioGuardias from './CalendarioGuardias.vue';
import Estadisticas from './Estadisticas.vue';

export default {
  install: (app, _options) => {
    app.component('CalendarioDisponibilidades', CalendarioDisponibilidades)
      .component('CalendarioGuardias', CalendarioGuardias)
      .component('GuardiasEstadisticas', Estadisticas);
  },
};
